import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Wordmark from "./Wordmark";

const NAV = [
  { to: "/learn", label: "Learn" },
  { to: "/topic/symptoms", label: "Symptoms" },
  { to: "/topic/diagnosis", label: "Diagnosis" },
  { to: "/topic/treatment", label: "Treatment" },
  { to: "/topic/diet", label: "Diet" },
  { to: "/faqs", label: "FAQs" },
  { to: "/resources", label: "Resources" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40"
      style={{ backgroundColor: "var(--cream)", borderBottom: "1px solid rgba(166,154,139,0.35)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Wordmark compact />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[0.72rem] uppercase wide-track editorial-link ${isActive ? "opacity-100" : "opacity-75 hover:opacity-100"}`
              }
              style={{ color: "var(--olive)" }}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="lg:hidden"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
          style={{ color: "var(--olive)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t" style={{ borderColor: "rgba(166,154,139,0.35)", backgroundColor: "var(--cream)" }}>
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className="text-sm uppercase wide-track"
                style={{ color: "var(--olive)" }}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
